import Swiper from "swiper";
import {Navigation, Mousewheel, Scrollbar} from 'swiper/modules';

function getSwiperType(swiperElement) {
  return swiperElement.getAttribute('data-swiper');
}

function getDefaultOptions(swiperElement) {
  return {
    direction: 'horizontal',
    speed: 500,
    updateOnResize: false,

    freeMode: {
      enabled: false,
      sticky: false,
      momentumBounce: false
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },

    scrollbar: {
      enabled: true,
      hide: false,
      draggable: true,
      el: `.swiper-scrollbar[data-swiper-scrollbar="${getSwiperType(swiperElement)}"]`,
    },

    navigation: {
      prevEl: `.swiper-navigation[data-swiper-navigation="${getSwiperType(swiperElement)}"] [data-swiper-button="prev"]`,
      nextEl: `.swiper-navigation[data-swiper-navigation="${getSwiperType(swiperElement)}"] [data-swiper-button="next"]`
    },
  }
}

const swiperSpecificOptions = {

  timelineOptions: swiperElement => {
    return {
      modules: [Navigation, Mousewheel, Scrollbar],

      ...getDefaultOptions(swiperElement),
      spaceBetween: 24,
      enableOpacityHandler: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },

      breakpoints: {
        1400: {
          slidesPerView: 1,
        },
        992: {
          slidesPerView: 1.125,
        },
        576: {
          slidesPerView: 1.125,
        },
        320: {
          slidesPerView: 1.125,
        }
      },
    }
  },
  systemsOptions: swiperElement => {
    return {
      modules: [Navigation, Mousewheel, Scrollbar],

      ...getDefaultOptions(swiperElement),
      spaceBetween: 24,
      enableOpacityHandler: false,

      breakpoints: {
        1400: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 1.25,
        },
        576: {
          slidesPerView: 1.25,
        },
        320: {
          slidesPerView: 1.125,
        }
      },
    }
  },
}

function getRecentOptions(swiperOptionsObject, swiperElement) {
  return swiperOptionsObject[`${getSwiperType(swiperElement)}Options`](swiperElement);
}

function initializeOpacityHandler(swiperInstance) {
  function handleSlideOpacity() {
    const containerRect = swiperInstance.el.getBoundingClientRect();
    const containerWidth = containerRect.width;

    swiperInstance.slides.forEach((slide) => {
      const slideRect = slide.getBoundingClientRect();
      const distanceFromLeftEdge = slideRect.left - containerRect.left;

      // Berechnung der Opacity basierend auf der Entfernung
      if (distanceFromLeftEdge < 0) {
        // Slide ist links und soll langsam an Opacity verlieren
        const opacity = Math.max(0, 1 + distanceFromLeftEdge / containerWidth);
        slide.style.opacity = opacity.toString();
      } else if (distanceFromLeftEdge >= 0 && distanceFromLeftEdge < containerWidth) {
        // Slide ist im Container oder rechts davon, behält Opacity 1
        slide.style.opacity = '1';
      }
    });
  }

  // Opacity kontinuierlich aktualisieren während des Swipens oder Scrollens
  swiperInstance.on('progress', handleSlideOpacity);

  // Setze die Opacity auch bei SetTranslate und SetTransition, um sicherzustellen,
  // dass sie auch bei Navigationsaktionen sofort aktualisiert wird.
  swiperInstance.on('setTranslate', handleSlideOpacity);
  swiperInstance.on('setTransition', handleSlideOpacity);

  handleSlideOpacity();  // Direkt bei Initialisierung anwenden
}

export function INIT_SWIPER() {
  const swiperElements = document.querySelectorAll('.swiper[data-swiper]');
  swiperElements.forEach(swiperElement => {
    const swiperType = getSwiperType(swiperElement);
    const swiperOptions = getRecentOptions(swiperSpecificOptions, swiperElement);
    const swiperInstance = new Swiper(`[data-swiper="${swiperType}"]`, swiperOptions);

   /* if (swiperOptions.enableOpacityHandler) {
      initializeOpacityHandler(swiperInstance);
    }*/
  });
}
